import { Apollo } from '../../lib/apollo';
const apollo = Apollo();
import {CREATE_EVENT_MUTATION, CREATE_IRRIGATION_ORDER_MUTATION, UPDATE_FAILTYPE_EVENT_MUTATION, UPDATE_DEVICE_EVENT_MUTATION} from '../../constants/graphql';

export default {
  state: {
    isUploading: false,
    events: {}
  },
  mutations: {
    addEvent (state, payload) {
      state.events[payload.key] = payload.value;
    },
    removeEvent (state, key) {
      delete state.events[key];
    },
    updateIsUploading (state, value) {
      state.isUploading = value;
    }
  },
  actions: {
    addEvent ({commit}, payload) {
      commit('addEvent', payload);
    },
    removeEvent ({commit}, key) {
      commit('removeEvent', key);
    },
    uploadStoreEvents (context) {
      context.commit('updateIsUploading', true);
      if (Object.entries(context.getters.events).length) {
        Object.entries(context.getters.events).forEach((event) => {
          if (event[1].note && event[1].note.length) {
            context.dispatch('uploadIrrigationOrder', {
              variables: event[1],
              comesFromStore: true,
              key: event[0]
            });
          } else if (event[1].auxObj) {
            context.dispatch('uploadCommonEvent', {
              variables: event[1].variables,
              auxObj: event[1].auxObj,
              comesFromStore: true,
              key: event[0]
            });
          }
        });
      }
      context.commit('updateIsUploading', false);
    },
    uploadIrrigationOrder (context, value) {
      apollo.defaultClient.mutate({
        mutation: CREATE_IRRIGATION_ORDER_MUTATION,
        variables: value.variables
      }).then(() => {
        if (value.comesFromStore) {
          context.commit('removeEvent', value.key);
        }
      }).catch(() => {
        if (!value.comesFromStore) {
          context.commit('addEvent', {
            key: Object.entries(context.getters.events).length,
            value: value.variables
          });
        }
      });
    },
    uploadCommonEvent (context, value) {
      apollo.defaultClient.mutate({
        mutation: CREATE_EVENT_MUTATION,
        variables: value.variables
      }).then((result) => {
        const id = result.data.createEvent.id;
        if (value.auxObj.selectedFailureType !== '') {
          apollo.defaultClient.mutate({
            mutation: UPDATE_FAILTYPE_EVENT_MUTATION,
            variables: {
              id,
              failTypeId: value.auxObj.selectedFailureType
            }
          }).then(() => {
          }).catch(() => {
          });
        }
        if (!value.auxObj.lastEventDate || value.auxObj.eventDate >= value.auxObj.lastEventDate) {
          apollo.defaultClient.mutate({
            mutation: UPDATE_DEVICE_EVENT_MUTATION,
            variables: {
              id,
              deviceId: parseInt(value.auxObj.deviceId)
            }
          }).then(() => {
            if (value.comesFromStore) {
              context.commit('removeEvent', value.key);
            }
          }).catch(() => {
          });
        }
      }).catch(() => {
        if (!value.comesFromStore) {
          context.commit('addEvent', {
            key: Object.entries(context.getters.events).length,
            value: {
              variables: value.variables,
              auxObj: value.auxObj
            }
          });
        }
      });
    }
  },
  getters: {
    events (state) {
      return state.events;
    },
    event ({state}, key) {
      return state.events[key];
    },
    isUploading (state) {
      return state.isUploading;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/events/index.js